module.exports = __webpack_public_path__ + "static/media/rocket-launch.0178576b.svg";